import axios from 'axios';

export function useCancelableRequests() {
    const controllers = new Map();

    function cancel(key) {
        const controller = controllers.get(key);
        if (controller) {
            controller.abort();
            controllers.delete(key);
        }
    }

    function cancelAll() {
        controllers.forEach(c => c.abort());
        controllers.clear();
    }

    async function request(key, config) {
        cancel(key);

        const controller = new AbortController();
        controllers.set(key, controller);

        try {
            const response = await axios({
                ...config,
                signal: controller.signal
            });

            controllers.delete(key);
            return response;
        } catch (e) {
            controllers.delete(key);
            throw e;
        }
    }

    return {
        request,
        cancel,
        cancelAll
    };
}